import { injectGlobal } from 'emotion';
import LatoBlack from './lato-black.woff';
import LatoBlack2 from './lato-black.woff2';
import LatoBlackItalic from './lato-blackitalic.woff';
import LatoBlackItalic2 from './lato-blackitalic.woff2';
// Note: We used the "black" versions instead of the "bold" versions
// import LatoBold from './lato-bold.woff';
// import LatoBold2 from './lato-bold.woff2';
// import LatoBoldItalic from './Lato-BoldItalic.woff';
// import LatoBoldItalic2 from './Lato-BoldItalic.woff2';
import LatoItalic from './lato-italic.woff';
import LatoItalic2 from './lato-italic.woff2';
import LatoRegular from './lato-regular.woff';
import LatoRegular2 from './lato-regular.woff2';
import LatoSemiBold from './lato-semibold.woff';
import LatoSemiBold2 from './lato-semibold.woff2';
import LatoSemiBoldItalic from './lato-semibolditalic.woff';
import LatoSemiBoldItalic2 from './lato-semibolditalic.woff2';

import VertexIconEot from './VertexIcon.eot';
import VertexIconSvg from './VertexIcon.svg';
import VertexIconTtf from './VertexIcon.ttf';
import VertexIconWoff from './VertexIcon.woff';

export const fontFamilyNames = {
    LatoRegular: 'LatoRegular',
    LatoBold: 'LatoBold',
    LatoItalic: 'LatoItalic',
    LatoBoldItalic: 'LatoBoldItalic',
    LatoSemiBold: 'Lato-SemiBold',
    LatoSemiBoldItalic: 'Lato-SemiBoldItalic',
    VertexIcon: 'VertexIcon',
};

export const injectFontsGlobally = (): void => {
    const psuedoNotChain =
        ':not(.ag-icon):not(.ag-checkbox-input-wrapper):not(.ag-radio-button-input-wrapper)';

    injectGlobal`
      *${psuedoNotChain},
      [class*='vtx-']:not(.vtx-icon),
      span${psuedoNotChain},
      div${psuedoNotChain},
      div${psuedoNotChain} div${psuedoNotChain}
      div${psuedoNotChain} span${psuedoNotChain} {
            font-family: "LatoRegular", sans-serif;
        }
        @font-face {
            font-family: ${fontFamilyNames.LatoRegular};
            src: url(${LatoRegular2}) format('woff2'),
                url(${LatoRegular}) format('woff');
            font-weight: normal;
            font-style: normal;
        }
        
        @font-face {
            font-family: ${fontFamilyNames.LatoBold};
            src: url(${LatoBlack2}) format('woff2'),
                url(${LatoBlack}) format('woff');
            font-weight: normal;
            font-style: normal;
        }
        
        @font-face {
            font-family: ${fontFamilyNames.LatoItalic};
            src: url(${LatoItalic2}) format('woff2'),
                url(${LatoItalic}) format('woff');
            font-weight: normal;
            font-style: normal;
        }
        
        @font-face {
            font-family: ${fontFamilyNames.LatoBoldItalic};
            src: url(${LatoBlackItalic2}) format('woff2'),
                url(${LatoBlackItalic}) format('woff');
            font-weight: normal;
            font-style: normal;
        }
        
        @font-face {
            font-family: ${fontFamilyNames.LatoSemiBold};
            src: url(${LatoSemiBold2}) format('woff2'),
                url(${LatoSemiBold}) format('woff');
            font-weight: normal;
            font-style: normal;
        }
        
        @font-face {
            font-family: ${fontFamilyNames.LatoSemiBoldItalic};
            src: url(${LatoSemiBoldItalic2}) format('woff2'),
                url(${LatoSemiBoldItalic}) format('woff');
            font-weight: normal;
            font-style: normal;
        }

        @font-face {
            font-family: ${fontFamilyNames.VertexIcon};
            src: url(${VertexIconEot});
            src: url(${VertexIconEot}) format('embedded-opentype'),
              url(${VertexIconTtf}) format('truetype'),
              url(${VertexIconWoff}) format('woff'),
              url(${VertexIconSvg}) format('svg');
            font-weight: normal;
            font-style: normal;
            font-display: block;
          }
    `;
};
